// @flow
import React from 'react';

import styles from './headerBar.scss';
import envConfig from '../../../configs/envConfig';
import {
  checkForAnonymousUser,
  createCn,
  checkForClientUser
} from '../../../services/helpers';
import SwitchClientDropdown from '../switchClientDropdown/switchClientDropdown';

const ticketingIconUrl = require('../../../assets/images/tickets.svg');

type Props = {
  toggleMenuBarDisplay: Function,
  toggleSwitchClientDisplay: Function,
  getClientsForSwitchClientOption: Function,
  getClientsFunction: Function,
  userProfile: Object,
  logout: Function,
  pageState?: Object,
  switchClientDropdownState: Object
};

const getUserDisplayEmail = userProfile => {
  let displayString = '';
  const emptyString = ' ';
  if (!userProfile) {
    return displayString;
  }
  if (userProfile.email) {
    displayString += emptyString + userProfile.email;
  }
  return displayString;
};

const getUserDisplayLocation = userProfile => {
  let displayString = '';
  const openingBracket = '(';
  const emptyString = ' ';
  const closingBracket = ')';
  if (!userProfile) {
    return displayString;
  }
  if (userProfile.location_name) {
    displayString += emptyString + userProfile.location_name;
  }
  if (userProfile.location_code) {
    displayString +=
      openingBracket + emptyString + userProfile.location_code + closingBracket;
  }
  return displayString;
};

const renderTicketLink = userProfile => {
  if (checkForClientUser(userProfile) || checkForAnonymousUser(userProfile)) {
    return null;
  }
  return (
    <div
      className={`${styles.ticketLinkWrapper} cursor-p l-row j-end`}
      onClick={() => window.open(envConfig.ticketingUrl, '_blank')}
    >
      <div className="l-row a-center j-center">
        <img
          className={styles.ticketIcon}
          src={ticketingIconUrl}
          alt="Loading..."
        />
      </div>
      <div className={`${styles.ticketText} l-row a-center j-center`}>
        TICKETS
      </div>
    </div>
  );
};

const renderSwitchClientDropdown = props => {
  if (!props.switchClientDropdownState.selectedClient) {
    props.getClientsFunction(null, '', true, false, null, val => {
      if (val.length) {
        props.getClientsForSwitchClientOption(val[0]);
      }
    });
  }
  return (
    <div className={`${styles.switchClientWrapper}`}>
      <div
        className="l-row a-center j-center"
        onClick={() =>
          props.toggleSwitchClientDisplay(
            !props.switchClientDropdownState.isSwitchClientVisible
          )
        }
      >
        {props.switchClientDropdownState.selectedClient &&
          props.switchClientDropdownState.selectedClient.displayName}{' '}
        &#9662;
      </div>
      <div className={`${styles.switchClientDiv}`}>
        <SwitchClientDropdown
          showSwitchClientOption={
            props.switchClientDropdownState.isSwitchClientVisible
          }
        />
      </div>
    </div>
  );
};

const HeaderBar = (props: Props) => (
  <>
    <header className={`${styles.headerWrapper}`}>
      <div className={` ${styles.headerContainer} l-row a-center`}>
        {/* <img
          className={styles.ticketIcon}
          style={{ marginLeft: '6rem' }}
          // className="menu-icn flex-12 cursor-p"
          src={ticketingIconUrl}
          alt="Loading..."
        /> */}
        <div className="header-left-part flex-56 l-row a-center">
          <div
            className="menu-icn flex-12 cursor-p"
            onClick={() => props.toggleMenuBarDisplay(true)}
          >
            <div className={`${styles.hamburgerIcn}`}>
              <span />
              <span />
              <span />
            </div>
          </div>
          <div className={`${styles.pageTitle}`}>
            {props.pageState.pageName}
            {props.pageState.betaPage ? (
              <span className={`${styles.betaSubTitle}`}> BETA </span>
            ) : null}
          </div>
          <div className="flex-15" />
        </div>
        <div
          className={`${styles.headerRightPart} flex-44 l-row a-center j-end`}
        >
          {/* {renderTicketLink(props.userProfile)} */}
          <div className={`${styles.userInfo} l-col`}>
            <div className="l-row a-center j-center">
              {getUserDisplayEmail(props.userProfile)}
            </div>
            <div className="l-row a-center j-center">
              {getUserDisplayLocation(props.userProfile)}
            </div>
          </div>
          {props.userProfile && props.userProfile.user_id && (
            <>
              {/* <div
                className="create-cn-icn cursor-p flex-13 l-row a-center j-center"
                onClick={() => createCn()}
              >
                +
              </div> */}
              <div
                className={` ${styles.logoutBtn} cursor-p flex-13 l-row j-center a-center`}
                onClick={() => {
                  props.logout(props.userProfile);
                }}
              >
                Logout
              </div>
            </>
          )}
        </div>
      </div>
    </header>
  </>
);

HeaderBar.defaultProps = {
  pageState: {
    pageName: '',
    betaPage: false
  }
};

export default HeaderBar;
